export const ifiWholeLifeDividendColumnHeaderMap = {
  PUA: [
    'policyYear',
    'ageEndYear',
    'contractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'annualDividendEndYear',
    'cashValueOfAdditionsEndYear',
    'totalCashValueEndYear',
    'paidUpAdditionsEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  Cash: [
    'policyYear',
    'ageEndYear',
    'contractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'dividendPaidInCashBegYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'totalCashValueEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  PRCash: [
    'policyYear',
    'ageEndYear',
    'contractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'netPremiumBegYear',
    'annualDividendEndYear',
    'dividendPaidInCashBegYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'totalCashValueEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  PRPUA: [
    'policyYear',
    'ageEndYear',
    'contractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'netPremiumBegYear',
    'annualDividendEndYear',
    'cashValueOfAdditionsEndYear',
    'totalCashValueEndYear',
    'paidUpAdditionsEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  Accumulate: [
    'policyYear',
    'ageEndYear',
    'contractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'annualDividendEndYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'cashValueOfAccumsEndYear',
    'totalCashValueEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  Concept: [
    'policyYear',
    'ageEndYear',
    'annualOutlayBegYear',
    'annualLoan',
    'withdrawAmount',
    'annualNetOutlayBegYear',
    'annualDividendEndYear',
    'guaranteedCashValueEndYear',
    'cashValueOfAdditionsEndYear',
    'totalOutstandingLoanEndYear',
    'netCashValueEndYear',
    'paidUpAdditionsEndYear',
    'netDeathBenefitEndYear',
  ],
};

export const ifiWholeLifeDividendWithRtrColumnHeaderMap = {
  PUA: [
    'policyYear',
    'ageEndYear',
    'guaranteedContractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'contractPremiumBegYear',
    'annualDividendEndYear',
    'cashValueOfAdditionsEndYear',
    'totalCashValueEndYear',
    'paidUpAdditionsEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  Cash: [
    'policyYear',
    'ageEndYear',
    'guaranteedContractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'contractPremiumBegYear',
    'dividendPaidInCashBegYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'totalCashValueEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  PRCash: [
    'policyYear',
    'ageEndYear',
    'guaranteedContractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'contractPremiumBegYear',
    'netPremiumBegYear',
    'annualDividendEndYear',
    'dividendPaidInCashBegYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'totalCashValueEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  PRPUA: [
    'policyYear',
    'ageEndYear',
    'guaranteedContractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'contractPremiumBegYear',
    'netPremiumBegYear',
    'annualDividendEndYear',
    'cashValueOfAdditionsEndYear',
    'totalCashValueEndYear',
    'paidUpAdditionsEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  Accumulate: [
    'policyYear',
    'ageEndYear',
    'guaranteedContractPremiumBegYear',
    'guaranteedCashValueEndYear',
    'guaranteedDeathBenefitEndYear',
    'contractPremiumBegYear',
    'annualDividendEndYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'cashValueOfAccumsEndYear',
    'totalCashValueEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  Concept: [
    'policyYear',
    'ageEndYear',
    'annualOutlayBegYear',
    'annualLoan',
    'withdrawAmount',
    'annualNetOutlayBegYear',
    'annualDividendEndYear',
    'guaranteedCashValueEndYear',
    'cashValueOfAdditionsEndYear',
    'totalOutstandingLoanEndYear',
    'netCashValueEndYear',
    'totalPaidUpInsuranceEndYear',
    'netDeathBenefitEndYear',
  ],
};

export const ifiWholeLifeSupplementalDividendColumnHeaderMap = {
  PUA: [
    'policyYear',
    'ageEndYear',
    'annualOutlayBegYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'annualDividendEndYear',
    'guaranteedCashValueEndYear',
    'cashValueOfAdditionsEndYear',
    'totalCashValueEndYear',
    'paidUpAdditionsEndYear',
    'totalDeathBenefitEndYear',
  ],
  Cash: [
    'policyYear',
    'ageEndYear',
    'annualOutlayBegYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'annualDividendEndYear',
    'guaranteedCashValueEndYear',
    'cashValueOfAdditionsEndYear',
    'totalCashValueEndYear',
    'paidUpAdditionsEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  PRCash: [
    'policyYear',
    'ageEndYear',
    'annualOutlayBegYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'annualDividendEndYear',
    'guaranteedCashValueEndYear',
    'cashValueOfAdditionsEndYear',
    'totalCashValueEndYear',
    'paidUpAdditionsEndYear',
    'totalDeathBenefitEndYear',
    'totalPaidUpInsuranceEndYear',
  ],
  PRPUA: [
    'policyYear',
    'ageEndYear',
    'annualOutlayBegYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'annualDividendEndYear',
    'guaranteedCashValueEndYear',
    'cashValueOfAdditionsEndYear',
    'totalCashValueEndYear',
    'paidUpAdditionsEndYear',
    'totalDeathBenefitEndYear',
  ],
  Accumulate: [
    'policyYear',
    'ageEndYear',
    'annualOutlayBegYear',
    'taxOnDistributionBegYear',
    'annualNetOutlayBegYear',
    'annualDividendEndYear',
    'guaranteedCashValueEndYear',
    'cashValueOfAccumsEndYear',
    'cashValueOfAdditionsEndYear',
    'totalCashValueEndYear',
    'paidUpAdditionsEndYear',
    'totalDeathBenefitEndYear',
  ],
};

export const wholeLifeColumns = {
  policyYear: {
    headerText: [['&nbsp;'], ['&nbsp;'], ['&nbsp;'], ['Year']],
    definition: {
      title: 'Year',
      body: 'The number of years the policy is assumed to have been in force at the end of the policy year.',
    },
  },
  ageEndYear: {
    headerText: [['&nbsp;'], ['Age'], ['End'], ['Year']],
    definition: {
      title: 'Age End Year',
      body: 'Issue age plus policy duration years.',
    },
  },
  annualOutlayBegYear: {
    headerText: [['&nbsp;'], ['Annual'], ['Outlay'], ['Beg Year']],
    definition: {
      title: 'Annual Outlay',
      body: 'This is the out-of-pocket cost, which is the Contract Premium adjusted for any dividends paid in cash, dividends used to reduce the premium, partial surrenders, decreases in face amount, loans taken and loan repayments for the policy year, with no adjustments for taxes due.',
    },
  },
  taxOnDistributionBegYear: {
    headerText: [['&nbsp;'], ['Tax on'], ['Distribution'], ['Beg Year']],
    definition: {
      title: 'Tax on Distribution Beg Year',
      body: 'This column includes tax on cash distributions, generally surrenders and dividends paid in cash that are in excess of cost basis, tax on interest earned on dividends left to accumulate at interest and/or any tax due because of a Modified Endowment Contract (MEC) status.',
    },
  },
  annualNetOutlayBegYear: {
    headerText: [['Annual'], ['Net'], ['Outlay'], ['Beg Year']],
    definition: {
      title: 'Annual Net Outlay Beg Year',
      body: 'This is the out-of-pocket cost, which is comprised of the Contract Premium and adjusted for any dividends, Paid-Up Additions, cash value released, loans taken, loan repayments made or taxes due at the beginning of the policy year.',
    },
  },
  annualDividendEndYear: {
    headerText: [['&nbsp;'], ['Annual'], ['Dividend'], ['End Year']],
    definition: {
      title: 'Annual Dividend End Year',
      body: 'The total amount of annual dividend payable. These values are based on the illustrated dividend schedule and are not guaranteed.',
    },
  },
  guaranteedCashValueEndYear: {
    headerText: [['Guaranteed'], ['Cash'], ['Value'], ['End Year']],
    definition: {
      title: 'Guaranteed Cash Value End Year',
      body: 'The cash value which is guaranteed under this policy based upon the illustrated Contract Premium for Guaranteed Values as of the end of the policy year.',
    },
    supplementalOverride: 'basicPolicyCashValueEndYear',
  },
  cashValueOfAdditionsEndYear: {
    headerText: [['Total Cash'], ['Value of'], ['Additions'], ['End Year']],
    definition: {
      title: 'Cash Value of Additions End Year',
      body: 'The total cash value as of the end of the policy year of the Paid-Up Additions purchased by dividends earned on the base policy. These values are based on the illustrated dividend schedule and are not guaranteed.',
    },
  },
  totalCashValueEndYear: {
    headerText: [['Total'], ['Cash'], ['Value'], ['End Year']],
    definition: {
      title: 'Total Cash Value End Year',
      body: 'The total cash value as of the end of the policy year including all guaranteed and non-guaranteed values. These values are based on the illustrated dividend schedule and are not guaranteed{{CirAddTotalCashValueEndYear}}.',
    },
  },
  paidUpAdditionsEndYear: {
    headerText: [['&nbsp;'], ['Paid-Up'], ['Additions'], ['End Year']],
    definition: {
      title: 'Paid-Up Additions End Year',
      body: 'The additional paid-up insurance death benefit as of the end of the policy year purchased by dividends earned on the base policy{{CirAddPaidupAdditionsEndYear}}. These values are based on the illustrated dividend schedule and are not guaranteed.',
    },
  },
  totalDeathBenefitEndYear: {
    headerText: [['Total'], ['Death'], ['Benefit'], ['End Year']],
    definition: {
      title: 'Total Death Benefit End Year',
      body: 'This is the amount that would be payable if death occurred at the end of the policy year. These values are based on the illustrated dividend schedule and are not guaranteed{{CirAddTotalDeathBenefitEndYear}}.',
    },
  },
  contractPremiumBegYear: {
    headerText: [['&nbsp;'], ['&nbsp;'], ['Contract'], ['Premium']],
    definition: {
      title: 'Contract Premium',
      body: 'The gross premium that is required to be paid at the beginning of the policy year for the benefits shown in this illustration.',
    },
  },
  guaranteedDeathBenefitEndYear: {
    headerText: [['Guaranteed'], ['Death'], ['Benefit'], ['End Year']],
    definition: {
      title: 'Guaranteed Death Benefit End Year',
      body: 'The amount of death benefit which is guaranteed to be payable for this policy at death based upon the illustrated Contract Premium for Guaranteed Values as of the end of the policy year.',
    },
  },
  dividendPaidInCashBegYear: {
    headerText: [['Dividend'], ['Paid in'], ['Cash'], ['Beg Year']],
    definition: {
      title: 'Dividend Paid in Cash Beg Year',
      body: 'The annual dividend which is illustrated as being paid in cash.',
    },
  },
  totalPaidUpInsuranceEndYear: {
    headerText: [['Total'], ['Paid-Up'], ['Insurance'], ['End Year']],
    definition: {
      title: 'Total Paid-Up Insurance End Year',
      body: 'The amount of fully paid-up insurance that could be purchased if the policy were converted to a fully paid-up policy as of the end of the policy year. These values are based on the illustrated dividend schedule and are not guaranteed.',
    },
  },
  cashValueOfAccumsEndYear: {
    headerText: [['Cash'], ['Value of'], ['Accums'], ['End Year']],
    definition: {
      title: 'Cash Value of Accums End Year',
      body: 'The total cash value of dividends left to accumulate at interest based on the illustrated, non-guaranteed dividend schedule.',
    },
  },
  guaranteedContractPremiumBegYear: {
    headerText: [['Contract'], ['Premium for'], ['Gtd Values'], ['Beg Year']],
    definition: {
      title: 'Contract Premium',
      body: 'The gross premium that is required to be paid at the beginning of the policy year for the benefits shown in this illustration.',
    },
  },
  netPremiumBegYear: {
    headerText: [['&nbsp;'], ['Net'], ['Premium'], ['Beg Year']],
    definition: {
      title: 'Net Premium Beg Year',
      body: 'The Contract Premium minus any non-guaranteed dividends used to reduce the policy premium.',
    },
  },
  basicPolicyCashValueEndYear: {
    headerText: [['Basic'], ['Policy'], ['Cash Value'], ['End Year']],
    definition: {
      title: 'Basic Policy Cash Value End Year',
      body: 'The guaranteed cash value of the base policy as of the end of the policy year. This does not include the cash value from paid-up additions (PUAs) or any other policy riders.',
    },
  },
};
